import React from "react";

const ValidationError = ({ errorMessage, customClassNames = "" }) => {
    return errorMessage ? (
        <>
            <div
                className={`invalid-input-message flex items-center ${customClassNames}`}
            >
                <i className="fas fa-exclamation-triangle"></i>
                <span className="invalid-input-message-text">
                    {errorMessage}
                </span>
            </div>
        </>
    ) : (
        <></>
    );
};

export default ValidationError;
